import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../../common/http/http-utils';

@Injectable()
export class Service {
  value = '';

  constructor(public http: HttpClient) {
  }

  createVapp(vdcID, vAppId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcID + '/vapp/' + vAppId + '/policy';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  updateVapp(vdcID, vAppId, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcID + '/vapp/' + vAppId + '/policy';
    return this.http
      .put(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  createVDC(vdcID, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcID + '/policy';
    return this.http
      .post(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }

  updateVDC(vdcID, obj) {
    let url = HttpUtils.getBaseUrl() + '/hybridity/api/dps/vdc/' + vdcID + '/policy';
    return this.http
      .put(url, JSON.stringify(obj))
      .map(
        (res:any) => this.value = res
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/apply-policy/apply-policy.service.ts